import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import LineClassDay from "../views/LineClassDay.vue";
import TicketCheck from "../views/TicketCheck.vue";
import LineClassDayVehicleDriver from "../views/LineClassDayVehicleDriver/LineClassDayVehicleDriver.vue";
import NodeStartCar from "../views/NodeStartCar.vue";
import ContractManage from "../views/ContractManage.vue";
import ContractView from "../views/ContractView.vue";
import StartNodeUploadView from "../views/StartNodeUploadView.vue";
import VehicleMap from "../views/VehicleMap.vue";
import VehicleMapV2 from "../views/VehicleMapV2.vue";
import TestModule from "../views/TestModule.vue";
import ReadIdCard from "../views/ReadIdCard.vue";

// 座位预定
import LineClass from "../views/seatReserve/LineClass.vue";
import LineClassDaySale from "../views/seatReserve/LineClassDaySale.vue";
import LineClassDaySaleQuery from "../views/seatReserve/LineClassDaySaleQuery.vue";
import InputPassengers from "../views/seatReserve/InputPassengers.vue";
import RefundTicket from "../views/seatReserve/RefundTicket.vue"; // 退票
import SalePayment from "../views/seatReserve/SalePayment.vue"; // 售票缴款
import HistoryOrder from "../views/seatReserve/HistoryOrder.vue"; // 历史订单
import TicketChange from "../views/seatReserve/TicketChange.vue"; // 历史订单

// 班线管理
import LineClassList from "../views/LineClassManagement/LineClassList.vue";
import LineClassListDetail from "../views/LineClassManagement/LineClassListDetail.vue";
import LineClassDayPrice from "../views/LineClassManagement/LineClassDayPrice.vue";

//车辆管理
import VehicleHome from "../views/VehicleManagement/VehicleHome.vue";
import VehicleInfo from "../views/VehicleManagement/VehicleInfo.vue";
import DriverInfo from "../views/VehicleManagement/DriverInfo.vue";

//新签到发车模式
import SelectVehicle from "../views/NewSignInMode/SelectVehicle.vue";
import SignInPage from "../views/NewSignInMode/SignInPage.vue";

//站点签到
import NodeSignIn from "../views/NodeSignIn/NodeSignIn.vue";

//班次功能
import SendClassMsg from "../views/ClassFunction/SendClassMsg.vue";

//系统功能
import RedisCacheManagement from "../views/SystemFunction/RedisCacheManagement.vue";

//车票功能
import TicketDetailChangeLineClass from "../views/TicketFunction/TicketDetailChangeLineClass.vue";

// 站点检票
import NodeList from "../views/NodeCheckManagement/NodeList.vue";

// 线路检票
import LineCheckTicket from "../views/LineCheckTicket/LineCheckTicket.vue";
// 线路发车
import LineCheckSendCar from "../views/LineCheckTicket/LineCheckSendCar.vue";

// 修改座位图
import LineClassEditSeatChart from "../views/LineClassManagement/LineClassEditSeatChart.vue";

// 拼车订单
import CarPoolUserDetail from "../views/CarPoolUserDetail/CarPoolUserDetail.vue";

// 上门接接驳订单
import TicketConnectOrder from "../views/TicketConnectOrder/TicketConnectOrder.vue";

// 导入页面相关路由配置
export default [
  {
    name: "SignInPage",
    path: "/SignInPage",
    component: SignInPage,
    meta: { title: "签到发车" },
  },
  {
    name: "SelectVehicle",
    path: "/SelectVehicle",
    component: SelectVehicle,
    meta: { title: "车辆选择" },
  },
  {
    name: "VehicleInfo",
    path: "/VehicleInfo",
    component: VehicleInfo,
    meta: { title: "车辆信息" },
  },
  {
    name: "DriverInfo",
    path: "/DriverInfo",
    component: DriverInfo,
    meta: { title: "司机信息" },
  },
  {
    name: "VehicleHome",
    path: "/VehicleHome",
    component: VehicleHome,
    meta: { title: "车辆管理" },
  },
  {
    name: "ReadIdCard",
    path: "/ReadIdCard",
    component: ReadIdCard,
    meta: { title: "读取司机身份证" },
  },
  {
    name: "TestModule",
    path: "/TestModule",
    component: TestModule,
    meta: { title: "测试模块" },
  },
  //未定义页面重定向到登陆页面
  {
    path: "*",
    redirect: "/login",
  },
  {
    name: "Home",
    path: "/",
    component: Home,
    meta: { title: "主菜单" },
  },
  {
    name: "Login",
    path: "/login",
    component: Login, //resolve => require(['@/views/Login.vue'], resolve),
    meta: { title: "登录" },
  },
  {
    name: "LineClassDay",
    path: "/LineClassDay",
    component: LineClassDay,
    meta: { title: "站务管理" },
  },
  {
    name: "TicketCheck",
    path: "/TicketCheck",
    component: TicketCheck,
    meta: { title: "检票" },
  },
  {
    name: "SecurityOrderAdd",
    path: "/SecurityOrderAdd",
    component: () => import("../views/SecurityOrderAdd/SecurityOrderAdd.vue"),
    meta: { title: "安检单新增" },
  },
  {
    name: "NodeVehicleStatus",
    path: "/NodeVehicleStatus",
    component: () => import("../views/NodeCheckManagement/NodeVehicleStatus.vue"),
    meta: { title: "站点车辆状态" },
  },
  {
    name: "BaggageAbnormalCheckIn",
    path: "/BaggageAbnormalCheckIn",
    component: () =>
      import("../views/BaggageAbnormalCheckIn/BaggageAbnormalCheckIn.vue"),
    meta: { title: "行李异常登记" },
  },
  {
    name: "LineClassDayVehicleDriver",
    path: "/LineClassDayVehicleDriver",
    component: LineClassDayVehicleDriver,
    meta: { title: "车辆管理" },
  },
  {
    name: "NodeStartCar",
    path: "/NodeStartCar",
    component: NodeStartCar,
    meta: { title: "站点发车" },
  },
  {
    name: "ContractManage",
    path: "/ContractManage",
    component: ContractManage,
    meta: { title: "合同管理" },
  },
  {
    name: "ContractView",
    path: "/ContractView",
    component: ContractView,
    meta: { title: "合同预览" },
  },
  {
    name: "VehicleMap",
    path: "/VehicleMap",
    component: VehicleMap,
    meta: { title: "车辆位置" },
  },
  {
    name: "VehicleMapV2",
    path: "/VehicleMapV2",
    component: VehicleMapV2,
    meta: { title: "车辆位置" },
  },
  {
    name: "LineClass",
    path: "/LineClass",
    component: LineClass,
    meta: { title: "线路班次" },
  },
  {
    name: "LineClassDaySale",
    path: "/LineClassDaySale",
    component: LineClassDaySale,
    meta: { title: "班线售票" },
  },
  {
    name: "LineClassDaySaleQuery",
    path: "/LineClassDaySaleQuery",
    component: LineClassDaySaleQuery,
    meta: { title: "售票详情" },
  },
  {
    name: "InputPassengers",
    path: "/InputPassengers",
    component: InputPassengers,
    meta: { title: "售票详情" },
  },
  {
    name: "RefundTicket",
    path: "/RefundTicket",
    component: RefundTicket,
    meta: { title: "退票管理" },
  },
  {
    name: "SalePayment",
    path: "/SalePayment",
    component: SalePayment,
    meta: { title: "售票缴款" },
  },
  {
    name: "LineClassList",
    path: "/LineClassList",
    component: LineClassList,
    meta: { title: "班线管理", keepAlive: true },
  },
  {
    name: "LineClassDayPrice",
    path: "/LineClassDayPrice",
    component: LineClassDayPrice,
    meta: { title: "班次票价" },
  },
  {
    name: "LineClassListDetail",
    path: "/LineClassListDetail",
    component: LineClassListDetail,
    meta: { title: "班线详情信息" },
  },
  {
    name: "LineClassEditSeatChart",
    path: "/LineClassEditSeatChart",
    component: LineClassEditSeatChart,
    meta: { title: "班线详情信息" },
  },
  {
    name: "StartNodeUploadView",
    path: "/StartNodeUploadView",
    component: StartNodeUploadView,
    meta: { title: "路单预览" },
  },
  {
    name: "SendClassMsg",
    path: "/SendClassMsg",
    component: SendClassMsg,
    meta: { title: "消息发送" },
  },
  {
    name: "TicketDetailChangeLineClass",
    path: "/TicketDetailChangeLineClass",
    component: TicketDetailChangeLineClass,
    meta: { title: "车票改乘" },
  },
  {
    name: "NodeList",
    path: "/NodeList",
    component: NodeList,
    meta: { title: "站点选择", keepAlive: true },
  },
  {
    name: "RedisCacheManagement",
    path: "/RedisCacheManagement",
    component: RedisCacheManagement,
    meta: { title: "缓存管理" },
  },
  {
    name: "NodeSignIn",
    path: "/NodeSignIn",
    component: NodeSignIn,
    meta: { title: "站点签到" },
  },
  {
    name: "HistoryOrder",
    path: "/HistoryOrder",
    component: HistoryOrder,
    meta: { title: "历史订单" },
  },
  {
    name: "LineCheckTicket",
    path: "/LineCheckTicket",
    component: LineCheckTicket,
    meta: { title: "线路检票" },
  },
  {
    name: "CarPoolUserDetail",
    path: "/CarPoolUserDetail",
    component: CarPoolUserDetail,
    meta: { title: "拼车订单" },
  },
  {
    name: "TicketConnectOrder",
    path: "/TicketConnectOrder",
    component: TicketConnectOrder,
    meta: { title: "接驳订单" },
  },
  {
    name: "LineCheckSendCar",
    path: "/LineCheckSendCar",
    component: LineCheckSendCar,
    meta: { title: "线路发车" },
  },
  {
    name: "TicketChange",
    path: "/TicketChange",
    component: TicketChange,
    meta: { title: "改签" },
    children: [
      {
        name: "TicketChangeLineClass",
        path: "/TicketChange/LineClass",
        component: LineClass,
        meta: { title: "线路班次" },
      },
      {
        name: "TicketChangeLineClassDaySale",
        path: "/TicketChange/LineClassDaySale",
        component: LineClassDaySale,
        meta: { title: "班线售票" },
      },
      {
        name: "TicketChangeLineClassDaySaleQuery",
        path: "/TicketChange/LineClassDaySaleQuery",
        component: LineClassDaySaleQuery,
        meta: { title: "售票详情" },
      },
    ],
  },
  {
    name: "VehicleMap1",
    path: "/VehicleMap1",
    component: (resolve) => require(["@/views/VehicleMap1.vue"], resolve),
    meta: { title: "车辆位置" },
  },
  {
    name: "AnalysisStats",
    path: "/AnalysisStats",
    component: (resolve) =>
      require(["@/views/AnalysisStats/Index.vue"], resolve),
    meta: { title: "统计分析" },
  },
  {
    name: "AnalysisStatsCheckStats",
    path: "/AnalysisStats/CheckStats",
    component: (resolve) =>
      require(["@/views/AnalysisStats/CheckStats.vue"], resolve),
    meta: { title: "统计分析" },
  },
  {
    name: "AnalysisStatsAttendanceRatio",
    path: "/AnalysisStats/AttendanceRatio",
    component: (resolve) =>
      require(["@/views/AnalysisStats/AttendanceRatio.vue"], resolve),
    meta: { title: "统计分析" },
  },
  {
    name: "AnalysisStatsOrderQuery",
    path: "/AnalysisStats/OrderQuery",
    component: (resolve) =>
      require(["@/views/AnalysisStats/OrderQuery.vue"], resolve),
    meta: { title: "统计分析" },
  },
];
